import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import useHttp from "../../hooks/useHttp";
import LinearProgress from "@mui/material/LinearProgress";
import { useRowSelector, useStoreDispatch, useStoreSelector } from "../../store/Hooks";
import { interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";
import { useEffect, useState } from "react";
import IntervalSet from "../../models/communications/IntervalSet";
import Interaction from "../../models/interactions/Interaction";
import EditorWrapper from "../ui/EditorWrapper";
import { postgrest_operators } from "../../helpers/HttpHelper";

interface IntervalSetEditorProps {
  interval_set: IntervalSet;
  interaction: Interaction;
  inDrawer?: boolean;
}

const IntervalSetEditor = (props: IntervalSetEditorProps) => {
  const { isLoading, sendRequest: fetchData } = useHttp();
  let intervalSet = useRowSelector(IntervalSet, props.interval_set.id); // can replace this with a working id to check
  let interaction = useRowSelector(Interaction, props.interaction.id); // can replace this with a working id to check

  if (typeof intervalSet === "undefined" || typeof interaction === "undefined") {
    return <></>;
  }

  const handleCloseWithoutSaving = async () => {
    // if we are closing without saving, we should revert redux UI for this interval
    // just pull the saved db state for this, and update the interval in redux with initial state
    IntervalSet.queryTable([
      {
        column: "id",
        operator: postgrest_operators.eq,
        value: props.interval_set.id.toString(),
      },
    ]);

  };

  const handleIntervalSetNameMapping = (value: string) => {
    if(intervalSet && interaction){
      intervalSet = intervalSet.update("name", "" + value)
      interaction = interaction.update("title", "" + value)
    } 
  };

  const save = async () => {
    if(intervalSet && interaction){
      if(intervalSet.name !== null && intervalSet.name !== ""){
        intervalSet = intervalSet.update("shared", true)
      }
       intervalSet.save();
       interaction.save();
    } 
  };

  return (
    <EditorWrapper
      save={save}
      cancel={handleCloseWithoutSaving}
      // delete={deleteIntervalSet}
      title={"Share Interval Set " + props.interval_set.id}
      inDrawer={props.inDrawer}
    >
      <Box data-testid="intervalSetEditorTest">
        <Grid container style={{}}>
          <Grid item xs={12} style={{}}>
            <div>
              <div style={{ padding: "10px" }}>
                <TextField
                  sx={{ width: "99%" }}
                  id="outlined-required"
                  label="Interval Set Name"
                  defaultValue={props.interval_set.name}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleIntervalSetNameMapping(event.target.value);
                  }}
                />
                <br />
                <h1 style={{ color: "red", textAlign: "center" }}>WARNING: </h1>
                <h2 style={{ color: "red", textAlign: "center" }}>
                  This set will now be available for modification by other
                  users!
                </h2>
              </div>
            </div>
            {isLoading && <LinearProgress />}
          </Grid>
        </Grid>
      </Box>
    </EditorWrapper>
  );
};

export default IntervalSetEditor;
